// extracted by mini-css-extract-plugin
export default {"Outer":"NewPie_Outer__mTNdl","innerText":"NewPie_innerText__oxyCJ","afterDecimal":"NewPie_afterDecimal__qCD6U","pieCard":"NewPie_pieCard__I49BH"};